import { render, staticRenderFns } from "./ProjectTableArsip.vue?vue&type=template&id=6cada7c9"
import script from "./ProjectTableArsip.vue?vue&type=script&lang=js"
export * from "./ProjectTableArsip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports